<script>
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
	export let tableName = '';
	export let tableActionName = '';
	const action = () => {
		dispatch('tableAction');
	};
</script>

<div class="table-container">
	<div class="table-heading">
		{#if tableName !== ''}
			<h3>{tableName}</h3>
		{/if}

		{#if tableActionName !== ''}
			<span />
			<button on:click={action}>+ {tableActionName}</button>
		{/if}
	</div>
	<div class="table">
		<table>
			<slot name="thead" />
			<slot name="tbody" />
		</table>
	</div>
</div>

<style>* {
  --brd-c: #ddd;
  --t-c: #43414b;
  --t-c-l: #727178;
  --em-1: 1em;
}

.table-container {
  padding: 15px;
  border: 1px solid var(--brd-c);
  border-radius: 4px;
}

.table-heading:has(h3, button) {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--em-1);
}

.table {
  overflow-y: scroll;
}

h3 {
  margin: unset;
  color: var(--t-c);
  font-size: 1.3rem;
}

:global(.table-heading button) {
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.4px;
  text-decoration-line: underline;
  color: #3a4bc4;
}

table {
  color: var(--t-c);
  width: 100%;
  overflow-y: scroll;
  padding: var(--em-1) 0 var(--em-1) var(--em-1);
  border-radius: 4px;
  border-collapse: collapse;
}

table :global(thead) {
  border-bottom: 2px solid var(--brd-c);
  text-align: left;
  color: var(--t-c-l);
}

table :global(th) {
  font-size: 1.1rem;
  font-weight: 300;
  letter-spacing: 0.4px;
  padding-right: var(--em-1);
}

table :global(tr) {
  border-bottom: 1px solid var(--brd-c);
}

table :global(tr:last-of-type) {
  border-bottom: none;
}

table :global(td) {
  padding: 11px 0;
  text-align: left;
  font-size: 1rem;
  padding-right: var(--em-1);
  white-space: nowrap;
}

table :global(td.right) {
  text-align: right;
  padding-right: unset;
}</style>
